import {Component, OnInit} from '@angular/core';
import {MoreMenuStateService} from '../services/more-menu-state.service';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {

  constructor(private moreMenuStateService: MoreMenuStateService) {
  }

  ngOnInit(): void {
  }

  getState(): boolean {
    return this.moreMenuStateService.getState();
  }

}
